import React from 'react';

export const LazyDataGrid = React.lazy(async () => {
	const module = await import(/* webpackChunkName: "grid" */ './DataGrid');

	return { default: module.DataGrid };
});
